// Calcul des heures de formation d'une journée (miroir de services_assiduite / services_bpf côté backend)
const minutes = (hhmm) => { if (!hhmm) return null; const [h, m] = hhmm.split(':').map(Number); return Number.isFinite(h) ? h * 60 + (m || 0) : null; };

// Heures prévues par le planning pédagogique : journée type de la formation, moitié pour une demi-journée
export const heuresPrevuesJournee = (formation, planningDay) => {
  const hpj = Number(formation?.heures_par_jour) || 7;
  return ['matin', 'apres_midi'].includes(planningDay?.demi_journee) ? hpj / 2 : hpj;
};

// Durée effective de la journée : horaires de l'action (matin / après-midi / journée) si connus, sinon modules réalisés, sinon heures prévues
export const dureeJournee = (cahier, formation, planningDay, horaires) => {
  if (horaires?.matin_debut && horaires?.am_fin) {
    const demi = planningDay?.demi_journee;
    const creneaux = demi === 'matin' ? [['matin_debut', 'matin_fin']] : demi === 'apres_midi' ? [['am_debut', 'am_fin']] : [['matin_debut', 'matin_fin'], ['am_debut', 'am_fin']];
    const total = creneaux.reduce((s, [d, f]) => s + Math.max(0, (minutes(horaires[f]) || 0) - (minutes(horaires[d]) || 0)), 0);
    if (total > 0) return Math.round(total / 60 * 100) / 100;
  }
  const total = (cahier?.modules_realises || []).reduce((s, m) => s + (Number(m.duree_heures) || 0), 0);
  return total > 0 ? total : heuresPrevuesJournee(formation, planningDay);
};

// Heures perdues par un retard d'arrivée (pause méridienne exclue)
export const heuresRetard = (horaires, presence, planningDay) => {
  if (!horaires || !presence || presence.statut !== 'retard' || !presence.heure_arrivee) return 0;
  const arr = minutes(presence.heure_arrivee);
  const debut = minutes(planningDay?.demi_journee === 'apres_midi' ? horaires.am_debut : horaires.matin_debut);
  if (arr == null || !debut || arr <= debut) return 0;
  let manque = arr - debut;
  if (planningDay?.demi_journee !== 'apres_midi') {
    const pd = minutes(horaires.matin_fin), pf = minutes(horaires.am_debut);
    if (pd && pf && arr >= pf) manque -= (pf - pd);
    else if (pd && pf && pd < arr && arr < pf) manque -= (arr - pd);
  }
  return Math.round(Math.max(0, manque) / 60 * 100) / 100;
};

// Heures perdues par un départ anticipé (pause méridienne exclue)
export const heuresDepartAnticipe = (horaires, presence, planningDay) => {
  if (!horaires || !presence || !['present', 'retard'].includes(presence.statut) || !presence.heure_depart) return 0;
  const dep = minutes(presence.heure_depart);
  const fin = minutes(planningDay?.demi_journee === 'matin' ? horaires.matin_fin : horaires.am_fin);
  if (dep == null || !fin || dep >= fin) return 0;
  let manque = fin - dep;
  if (planningDay?.demi_journee !== 'matin') {
    const pd = minutes(horaires.matin_fin), pf = minutes(horaires.am_debut);
    if (pd && pf && dep <= pd) manque -= (pf - pd);
    else if (pd && pf && pd < dep && dep < pf) manque -= (pf - dep);
  }
  return Math.round(Math.max(0, manque) / 60 * 100) / 100;
};

// Heures validées pour un candidat : absent = 0 ; retard d'arrivée et départ anticipé déduits (miroir du BPF)
export const heuresCandidat = (presence, cahier, formation, planningDay, horaires) => {
  if (!presence || !['present', 'retard'].includes(presence.statut)) return 0;
  const duree = dureeJournee(cahier, formation, planningDay, horaires);
  const retenue = Math.min(duree, heuresRetard(horaires, presence, planningDay)) + Math.min(duree, heuresDepartAnticipe(horaires, presence, planningDay));
  return Math.round(Math.max(0, duree - retenue) * 100) / 100;
};

export const fmtH = (v) => `${Number(v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 2 })} h`;
